import { render, staticRenderFns } from "./myproductorders.vue?vue&type=template&id=98f4ad22&"
import script from "./myproductorders.vue?vue&type=script&lang=js&"
export * from "./myproductorders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports